export interface Stock {
  name: string;
  symbol: string;
  mt5Name?: string;
  mt5Symbol?: string;
  image?: string;
  trendingImage?: string;
  currency?: string;
  value?: number | string;
  percent?: number | string;
}

function getUniqueValues<T>(
  array1: T[],
  array2: T[],
  propName: string = 'symbol'
): T[] {
  const combinedArray = [...array1, ...array2];
  const uniqueStocksMap = new Map<string, Stock>();

  combinedArray.forEach((stock) => {
    uniqueStocksMap.set(stock?.[propName], stock);
  });

  return Array.from(uniqueStocksMap.values());
}

export const marketType = [
  {
    key: 'NASDAQ',
    name: 'Stocks',
  },
  {
    key: 'FOREX',
    name: 'Forex',
  },
  {
    key: 'COMMODITY',
    name: 'Commodities',
  },
  {
    key: 'CRYPTO',
    name: 'Crypto',
  },
];

export const homeTemp: Stock[] = [
  {
    name: 'Apple',
    symbol: 'AAPL',
    mt5Symbol: 'APPLE.',
    mt5Name: 'Apple Inc. (AAPL)',
    image: '/img/markets/crypto/new/icons/Apple.svg',
  },
  {
    name: 'Tesla',
    symbol: 'TSLA',
    mt5Symbol: 'TESLA.',
    mt5Name: 'Tesla Inc. (TSLA)',
    image: '/img/markets/crypto/new/icons/Tesla 2.svg',
  },
  {
    symbol: 'XAUUSD',
    name: 'Gold',
    mt5Symbol: 'XAUUSD',
    mt5Name: 'Gold (EUR)',
    image: '/img/markets/crypto/new/icons/GOLD 2.svg',
    trendingImage: '/img/markets/commodities/gold.webp',
    currency: 'EUR',
  },
  {
    name: 'Nosdaq',
    symbol: 'Nosdaq (IXIC)',
    mt5Symbol: 'US100',
    mt5Name: 'Apple Inc. (AAPL)',
    image: '/img/markets/crypto/new/icons/nasdaq-icon-24m.svg',
  },
];

export const topStocks: Stock[] = [
  {
    name: 'Microsoft',
    symbol: 'MSFT',
    mt5Symbol: 'MICROSOFT.',
    mt5Name: 'Microsoft (MSFT)',
    image: '/img/markets/crypto/new/icons/microsoft 1.svg',
  },
  {
    name: 'Tesla',
    symbol: 'TSLA',
    mt5Symbol: 'TESLA.',
    mt5Name: 'Tesla Inc. (TSLA)',
    image: '/img/markets/crypto/new/icons/Tesla 2.svg',
  },
  {
    name: 'Amazon',
    symbol: 'AMZN',
    mt5Symbol: 'AMAZON.',
    mt5Name: 'Amazon.com Inc. (AMZN)',
    image: '/img/markets/crypto/new/icons/amazon 2.svg',
  },
  {
    name: 'Meta',
    symbol: 'META',
    mt5Symbol: 'Facebook.',
    mt5Name: 'Meta Platforms Inc. (META)',
    image: '/img/markets/crypto/new/icons/meta 2.svg',
  },
  {
    name: 'Apple',
    symbol: 'AAPL',
    mt5Symbol: 'APPLE.',
    mt5Name: 'Apple Inc. (AAPL)',
    image: '/img/markets/crypto/new/icons/Apple.svg',
  },
];
export const marketStocks: Stock[] = [
  {
    name: 'Tesla',
    symbol: 'TSLA',
    mt5Symbol: 'TESLA.',
    mt5Name: 'Tesla Inc. (TSLA)',
    image: '/img/stock-images/tesla 1.webp',
  },
  {
    name: 'Apple',
    symbol: 'AAPL',
    mt5Symbol: 'APPLE.',
    mt5Name: 'Apple Inc. (AAPL)',
    image: '/img/stock-images/Apple 1.webp',
  },
  {
    name: 'Microsoft',
    symbol: 'MSFT',
    mt5Symbol: 'MICROSOFT.',
    mt5Name: 'Microsoft (MSFT)',
    image: '/img/stock-images/microsoft 1.webp',
  },
  {
    name: 'Netflix',
    symbol: 'NFLX',
    mt5Symbol: 'NETFLIX.',
    mt5Name: 'Netflix Inc. (NFLX)',
    image: '/img/stock-images/Netflix 1.webp',
  },
  {
    name: 'Meta',
    symbol: 'META',
    mt5Symbol: 'Facebook.',
    mt5Name: 'Meta Platforms Inc. (META)',
    image: '/img/stock-images/meta 1.webp',
  },
  {
    name: 'Uber',
    symbol: 'UBER',
    mt5Symbol: 'UBER.',
    mt5Name: 'Uber Technologies Inc. (UBER)',
    image: '/img/stock-images/Uber 1.webp',
  },
  {
    name: 'Google',
    symbol: 'GOOG',
    mt5Symbol: 'GOOGLE.',
    mt5Name: 'Alphabet Inc. (GOOGL)',
    image: '/img/stock-images/Google 1.webp',
  },
  {
    name: 'Amd',
    symbol: 'AMD',
    mt5Symbol: 'AMD.',
    mt5Name: 'Advanced Micro Devices (AMD)',
    image: '/img/stock-images/Amd1.webp',
  },
  {
    name: 'Amazon',
    symbol: 'AMZN',
    mt5Symbol: 'AMAZON.',
    mt5Name: 'Amazon.com Inc. (AMZN)',
    image: '/img/stock-images/amazon 1.webp',
  },
  {
    name: 'Nvidia',
    symbol: 'NVDA',
    mt5Symbol: 'NVIDIA.',
    mt5Name: 'NVIDIA Corporation (NVDA)',
    image: '/img/stock-images/invidia 1.webp',
  },
];

export const topForex: Stock[] = [
  {
    name: 'EUR/USD',
    symbol: 'EURUSD',
    mt5Name: 'Euro/USD',
    mt5Symbol: 'EURUSD',
    image: '/img/markets/crypto/new/icons/Frame-3.svg',
    trendingImage: '/img/markets/currencies/euro_usd.svg',
  },
  {
    symbol: 'USDJPY',
    mt5Symbol: 'USDJPY',
    mt5Name: 'USD/Yen',
    name: 'USD/JPY',
    image: '/img/markets/crypto/new/icons/Frame-2.svg',
    trendingImage: '/img/markets/currencies/usd_jpy.webp',
  },
  {
    symbol: 'AUDCHF',
    mt5Symbol: 'AUDCHF',
    mt5Name: 'AUD/CHF',
    name: 'AUD/CHF',
    image: '/img/markets/crypto/new/icons/Frame.svg',
    trendingImage: '/img/markets/currencies/aud_chf.webp',
  },
  {
    symbol: 'EURCHF',
    name: 'EUR/CHF',
    mt5Symbol: 'EURCHF',
    mt5Name: 'Euro/CHF',
    image: '/img/markets/crypto/new/icons/Frame-1.svg',
    trendingImage: '/img/markets/currencies/euro_chf.webp',
  },
  {
    symbol: 'GBPUSD',
    mt5Symbol: 'GBPUSD',
    mt5Name: 'Pound/USD',
    name: 'GBP/USD',
    image: '/img/markets/crypto/new/icons/Frame-4.svg',
    trendingImage: '/img/markets/currencies/gbp_usd.webp',
  },
];
export const marketForex: Stock[] = [
  {
    name: 'EUR/USD',
    symbol: 'EURUSD',
    mt5Name: 'Euro/USD',
    mt5Symbol: 'EURUSD',
    image: '/img/forex__4.svg',
    trendingImage: '/img/markets/currencies/euro_usd.svg',
  },
  {
    symbol: 'USDJPY',
    mt5Symbol: 'USDJPY',
    mt5Name: 'USD/Yen',
    name: 'USD/JPY',
    image: '/img/forex__2.svg',
    trendingImage: '/img/markets/currencies/usd_jpy.webp',
  },
  {
    symbol: 'GBPUSD',
    mt5Symbol: 'GBPUSD',
    mt5Name: 'Pound/USD',
    name: 'GBP/USD',
    trendingImage: '/img/markets/currencies/gbp_usd.webp',
  },
  {
    symbol: 'NZDUSD',
    mt5Symbol: 'NZDUSD',
    mt5Name: 'Kiwi/USD',
    name: 'NZD/USD',
    trendingImage: '/img/markets/currencies/nzd_usd.webp',
  },
  {
    symbol: 'USDCHF',
    mt5Symbol: 'USDCHF',
    mt5Name: 'USD/Swiss',
    name: 'USD/CHF',
    trendingImage: '/img/markets/currencies/usd_chf.webp',
  },
  {
    symbol: 'USDCAD',
    mt5Symbol: 'USDCAD',
    mt5Name: 'USD/Loonie',
    name: 'USD/CAD',
    trendingImage: '/img/markets/currencies/usdcad.webp',
  },
  {
    symbol: 'USDSEK',
    mt5Symbol: 'USDSEK',
    mt5Name: 'USD/Krona',
    name: 'USD/SEK',
    trendingImage: '/img/markets/currencies/usd_sek.webp',
  },
  {
    symbol: 'USDSGD',
    mt5Symbol: 'USDSGD',
    mt5Name: 'USD/Sing',
    name: 'USD/SGD',
    trendingImage: '/img/markets/currencies/usd_sgd.webp',
  },
  {
    symbol: 'USDZAR',
    mt5Symbol: 'USDZAR',
    mt5Name: 'USD/Rand',
    name: 'USD/ZAR',
    trendingImage: '/img/markets/currencies/usd_zar.webp',
  },
  {
    symbol: 'AUDUSD',
    name: 'AUD/USD',
    mt5Symbol: 'AUDUSD',
    mt5Name: 'Aussie/USD',
    trendingImage: '/img/markets/currencies/aud_usd.webp',
  },
];

export const topCommodities: Stock[] = [
  {
    symbol: 'XAUUSD',
    name: 'Gold',
    mt5Symbol: 'XAUUSD',
    mt5Name: 'Gold (EUR)',
    image: '/img/markets/crypto/new/icons/GOLD 2.svg',
    trendingImage: '/img/markets/commodities/gold.webp',
    currency: 'EUR',
  },
  {
    symbol: 'UKOil',
    name: 'Brent Crude Oil',
    mt5Symbol: 'UKOil',
    mt5Name: 'Brent Crude Oil',
    image: '/img/markets/crypto/new/icons/oil 1.svg',
    trendingImage: '/img/markets/commodities/eurooil.webp',
    currency: 'USD',
  },
  {
    symbol: 'CLUSD',
    name: 'Crude Oil',
    mt5Symbol: 'USOil',
    mt5Name: 'WTI Crude Oil',
    image: '/img/markets/crypto/new/icons/oil 1.svg',
    trendingImage: '/img/markets/commodities/crude_oil.webp',
    currency: 'USD',
  },
  {
    symbol: 'NGUSD',
    name: 'Natural Gas',
    mt5Symbol: 'XNGUSD',
    mt5Name: 'Natural Gas',
    image: '/img/markets/crypto/new/icons/NATGAS 2.svg',
    trendingImage: '/img/markets/commodities/natgas.webp',
    currency: 'USD',
  },
  {
    symbol: 'SIUSD',
    name: 'Silver',
    mt5Symbol: 'XAGUSD',
    mt5Name: 'Silver',
    image: '/img/markets/crypto/new/icons/Silver 1.svg',
    trendingImage: '/img/markets/commodities/silver.webp',
    currency: 'USD',
  },
];
export const marketCommodities: Stock[] = [
  {
    symbol: 'GCUSD',
    name: 'Gold',
    mt5Symbol: 'XAUUSD',
    mt5Name: 'Gold (USD)',
    image: '/img/commodities__1.webp',
    trendingImage: '/img/markets/commodities/gold.webp',
    currency: 'USD',
  },
  {
    symbol: 'UKOil',
    name: 'Brent Crude Oil',
    mt5Symbol: 'UKOil',
    mt5Name: 'Brent Crude Oil',
    image: '/img/commodities__3.webp',
    trendingImage: '/img/markets/commodities/eurooil.webp',
    currency: 'USD',
  },
  {
    symbol: 'CLUSD',
    name: 'Crude Oil',
    mt5Symbol: 'USOil',
    mt5Name: 'WTI Crude Oil',
    image: '/img/commodities__3.webp',
    trendingImage: '/img/markets/commodities/crude_oil.webp',
    currency: 'USD',
  },
  {
    symbol: 'NGUSD',
    name: 'Natural Gas',
    mt5Symbol: 'XNGUSD',
    mt5Name: 'Natural Gas',
    trendingImage: '/img/markets/commodities/natgas.webp',
    currency: 'USD',
  },
  {
    symbol: 'SIUSD',
    name: 'Silver',
    mt5Symbol: 'XAGUSD',
    mt5Name: 'Silver',
    image: '/img/commodities__4.webp',
    trendingImage: '/img/markets/commodities/silver.webp',
    currency: 'USD',
  },
  {
    symbol: 'PLUSD',
    name: 'Palladium',
    mt5Symbol: 'XPDUSD',
    mt5Name: 'Palladium',
    trendingImage: '/img/markets/commodities/pd.webp',
    currency: 'USX',
  },
  {
    symbol: 'XPTUSD',
    name: 'Platinum',
    mt5Symbol: 'XPTUSD',
    mt5Name: 'Platinum',
    trendingImage: '/img/markets/commodities/pt.webp',
    currency: 'USD',
  },
];

export const topCrypto: Stock[] = [
  {
    symbol: 'BTCUSD',
    name: 'Bitcoin',
    currency: 'USD',
    mt5Symbol: 'Bitcoin',
    mt5Name: 'Bitcoin',
    image: '/img/markets/crypto/new/icons/Bitcoin.svg',
    trendingImage: '/img/markets/crypto/bitcoin.webp',
  },
  {
    symbol: 'LTCUSD',
    name: 'Litecoin',
    mt5Symbol: 'Litecoin',
    mt5Name: 'Litecoin',
    currency: 'USD',
    image: '/img/markets/crypto/new/icons/Litecoin.svg',
    trendingImage: '/img/markets/crypto/litecoin.webp',
  },
  {
    symbol: 'DOGEUSD',
    name: 'Dogecoin',
    mt5Symbol: 'Dogecoin',
    mt5Name: 'Dogecoin',
    currency: 'USD',
    image: '/img/markets/crypto/new/icons/doge.svg',
    trendingImage: '/img/markets/crypto/dogecoin.webp',
  },
  {
    symbol: 'DASHUSD',
    name: 'Dash',
    mt5Symbol: 'Dash',
    mt5Name: 'Dash',
    currency: 'USD',
    image: '/img/markets/crypto/new/icons/Dash.svg',
    trendingImage: '/img/markets/crypto/solana.webp',
  },
  {
    symbol: 'EOSUSD',
    name: 'EOS',
    mt5Symbol: 'EOS',
    mt5Name: 'EOS',
    currency: 'USD',
    image: '/img/markets/crypto/new/icons/Eos.svg',
    trendingImage: '/img/markets/crypto/usdc.webp',
  },
  // {
  //   symbol: 'ETHUSD',
  //   name: 'Ethereum',
  //   mt5Symbol: 'Ethereum',
  //   mt5Name: 'Ethereum',
  //   currency: 'USD',
  //   image: '/img/markets/crypto/new/icons/Etherium.svg',
  //   trendingImage: '/img/markets/crypto/ethereum.webp',
  // },
  // {
  //   symbol: 'XRPUSD',
  //   name: 'Ripple',
  //   mt5Symbol: 'Ripple',
  //   mt5Name: 'Ripple',
  //   currency: 'USD',
  //   image: '/img/markets/crypto/new/icons/Ripple.svg',
  //   trendingImage: '/img/markets/crypto/ripple.webp',
  // },
];
export const marketCrypto: Stock[] = [
  {
    symbol: 'ADAUSD',
    name: 'Cardano',
    mt5Symbol: 'Cardano',
    mt5Name: 'Cardano',
    currency: 'USD',
    image: '/img/markets/crypto/new/icons/Cardano.svg',
    trendingImage: '/img/markets/crypto/cardano.webp',
  },
  // The following does not have a trending image
  {
    symbol: 'XLMUSD',
    name: 'Stellar',
    mt5Symbol: 'Stellar',
    mt5Name: 'Stellar',
    currency: 'USD',
    image: '/img/markets/crypto/new/icons/Stellar.svg',
    trendingImage: '/img/markets/crypto/xrp.webp',
  },
];

export const topIndices = [
  {
    name: 'US Tech 100',
    symbol: 'TECH100',
    mt5Symbol: 'US100',
    mt5Name: 'Nasdaq 100 (US100)',
    image: '/img/markets/crypto/new/icons/2YUS.svg',
    trendingImage: '/img/markets/indicies/usa.webp',
  },
  {
    name: 'Germany 40',
    symbol: 'DAX40',
    mt5Symbol: 'DE40',
    mt5Name: 'DAX 40 (Germany40)',
    image: '/img/markets/crypto/new/icons/Germany.svg',
    trendingImage: '/img/markets/indicies/germany.webp',
  },
  {
    name: 'EU 50',
    symbol: 'EU50',
    mt5Symbol: 'EU50',
    mt5Name: 'Euro Stoxx 50 (EU50)',
    image: '/img/markets/crypto/new/icons/EUSTX50.svg',
    trendingImage: '/img/markets/indicies/eu.webp',
  },
  {
    name: 'UK 100',
    symbol: 'FTSE100',
    mt5Symbol: '100UK',
    mt5Name: 'FTSE 100 (UK100)',
    image: '/img/markets/crypto/new/icons/UK 1.svg',
    trendingImage: '/img/markets/indicies/uk.webp',
  },
  {
    name: 'USA 500',
    symbol: 'US500',
    mt5Symbol: 'US500',
    mt5Name: 'S&P 500',
    image: '/img/markets/crypto/new/icons/2YUS.svg',
    trendingImage: '/img/markets/indicies/usa.webp',
  },
];
export const marketIndices: Stock[] = [
  {
    name: 'USA 500',
    symbol: 'US500',
    mt5Symbol: 'US500',
    mt5Name: 'S&P 500',
    trendingImage: '/img/markets/indicies/usa.webp',
  },
  {
    name: 'USA 30',
    symbol: 'US30',
    mt5Symbol: 'US30',
    mt5Name: 'Dow Jones',
    trendingImage: '/img/markets/indicies/usa.webp',
  },
  {
    name: 'USA 100',
    symbol: 'US100',
    mt5Symbol: 'US100',
    mt5Name: 'Nasdaq 100',
    trendingImage: '/img/markets/indicies/usa.webp',
  },
  {
    name: 'UK 100',
    symbol: 'FTSE100',
    mt5Symbol: '100UK',
    mt5Name: 'FTSE 100',
    image: '/img/indices__4.webp',
    trendingImage: '/img/markets/indicies/uk.webp',
  },
  {
    name: 'GB 100',
    symbol: 'UK100',
    mt5Symbol: '100UK',
    mt5Name: 'FTSE 100',
    trendingImage: '/img/markets/indicies/uk.webp',
  },
  {
    name: 'DE 40',
    symbol: 'DE40',
    mt5Symbol: 'DE40',
    mt5Name: 'DAX 40',
    trendingImage: '/img/markets/indicies/germany.webp',
  },
  {
    name: 'FR 40',
    symbol: 'FR40',
    mt5Symbol: 'FRA40',
    mt5Name: 'CAC 40',
    trendingImage: '/img/markets/indicies/france.webp',
  },
  {
    name: 'EU 50',
    symbol: 'EU50',
    mt5Symbol: 'EU50',
    mt5Name: 'Euro Stoxx 50',
    trendingImage: '/img/markets/indicies/eu.webp',
  },
  {
    name: 'ES 35',
    symbol: 'ES35',
    mt5Symbol: 'SPA35',
    mt5Name: 'IBEX 35',
    trendingImage: '/img/markets/indicies/spain.webp',
  },
  {
    name: 'ASX 200',
    symbol: 'AUS200',
    mt5Symbol: 'AUS200',
    mt5Name: 'ASX 200',
    trendingImage: '/img/markets/indicies/australia.webp',
  },
];

export const topMarketData = [
  ...topForex,
  ...topCommodities,
  ...topStocks,
  ...topCrypto,
];
export const tempMarketData = [
  {
    name: 'jojo',
    symbol: 'BTCUSD',
    mt5Symbol: 'Bitcoin',
    mt5Name: 'Bitcoin',
    image: '/img/markets/crypto/new/icons/Bitcoin.svg',
  },
];

export const allMarketData = [
  ...getUniqueValues(topForex, marketForex),
  ...getUniqueValues(topStocks, marketStocks),
  ...getUniqueValues(topCommodities, marketCommodities),
  ...getUniqueValues(topCrypto, marketCrypto),
];

export function isMoreThan24Hours(date: Date) {
  const givenDate = new Date(date);
  const currentDate = new Date();
  const differenceInMillis = currentDate - givenDate;
  const differenceInHours = differenceInMillis / (1000 * 60 * 60);
  return differenceInHours > 24;
}

export const groupByExchange = (
  values: Stock[] = [],
  marketData: Stock[] = []
): Record<string, unknown> => {
  const grouped = {};

  const customData = values.map((stock) => {
    const stockInfo = marketData.find((s) => s.symbol === stock.symbol);

    return {
      ...stock,
      ...stockInfo,
    };
  });

  customData.forEach((item) => {
    if (!grouped[item.exchange]) {
      grouped[item.exchange] = [];
    }
    grouped[item.exchange].push(item);
  });

  return grouped;
};

export const getValue = (stock: any, attr: string) => {
  const value = stock?.[attr];
  return value !== undefined ? `$${value.toFixed(2)}` : '$0.00';
};

export const getPercentageValue = (stock: any, attr: string) => {
  const value = stock?.[attr];
  return value !== undefined ? `${value.toFixed(2)}%` : '0.00%';
};

export const getValueTrend = (stock: any, attr: string) => {
  const change = stock?.[attr];
  return change && change.toString()[0] === '-'
    ? 'down'
    : change
      ? 'up'
      : 'default';
};

export function getRandomNumber(min: number, max: number, fixed = 2) {
  return Number(Math.random() * (max - min) + min).toFixed(fixed);
}
